import { apiClient } from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";
import { getUserData } from "../utils/authnicate";

/**
 * Create a new SPOC user.
 * POST api/SpocCreation/create-spoc
 */
export const createSpocAction = async (formData) => {
  const user = getUserData();
  const payload = {
    userName:
      formData.employeeName?.trim() || formData.employeeId?.trim() || "",
    email: formData.email?.trim() || "",
    password: formData.password?.trim() || "",
    role: formData.role?.trim() || "",
    lobType: formData.lob?.trim() || "",
    department: formData.department?.trim() || "",
    createdBy: user?.email || user?.userName || "admin",
  };

  console.log("[createSpoc] → POST create-spoc | payload:", payload);

  try {
    const response = await apiClient.post(ATP_API_URL.SPOC_CREATE, payload);

    console.log("[createSpoc] ← response:", response?.status, response?.data);

    if (response?.status === 200 || response?.status === 201) {
      if (response.data?.success === false) {
        console.warn(
          "[createSpoc] API returned success=false:",
          response.data.message,
        );
        return {
          success: false,
          message: response.data.message || "Failed to create SPOC",
        };
      }
      return {
        success: true,
        message: response.data?.message || "SPOC created successfully",
        data: response.data,
      };
    }

    console.error("[createSpoc] Unexpected status:", response?.status);
    return { success: false, message: "Failed to create SPOC" };
  } catch (error) {
    console.error(
      "[createSpoc] Error:",
      error?.response?.data || error.message,
    );
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error.message ||
        "Failed to create SPOC",
    };
  }
};
